<!-- enrollment.component.html -->
<app-entity-mat-dialog-title title="Enrollment" [closeData]="dataSaved ? { saved: true } : undefined"></app-entity-mat-dialog-title>

<div [ngClass]="{
        'loading-shade': showProgressSpinner
     }">

    <div mat-dialog-content class="mat-tab-header">

        <mat-progress-spinner class="matProgressSpinnerCentered" *ngIf="showProgressSpinner" mode="indeterminate"></mat-progress-spinner>

        <mat-tab-group class="eventTabGroup" [selectedIndex]="this.selectedIndex" (selectedTabChange)="setFormMode($event.index)" animationDuration="0ms" #tabs>

            <mat-tab label="View" [disabled]="this.initActionType == 'create'">

                <div class="container-fluid">
                    <div class="row">
                        <!-- Use the new enrollment-agreement-display component -->
                        <app-enrollment-agreement-display
                            [entityData]="entityData"
                            [studentAccountEntityData]="studentAccountEntityData"
                            [studioInformationConfig]="studioInformationConfig"
                            [enrollmentForm]="enrollmentForm"
                            [displaySignatures]="true"
                            [_enrollmentEntityData]="_enrollmentEntityData"
                            [isTaxInclusive]="isTaxInclusive"
                            [taxConfig]="taxConfig"
                            [templateKey]="activeTemplateKey"
                            (printRequested)="printPage($event.showBackOnly, $event.showFrontOnly)">
                        </app-enrollment-agreement-display>

                        <div id="enrollment-agreement-backpage" class="page2">
                            <div [innerHTML]="backpageHtmlContent"></div>
                        </div>

                        <div class="row mt-3 mb-3">
                            <div class="col-6">
                                <button style="background-color: transparent !important; border: none;"
                                    (click)="printPage(false, true)"
                                    type="button"
                                    mat-icon-button
                                    class="me-1 mb-1"
                                    matTooltip="Print agreement"
                                    matTooltipPosition="below"
                                    aria-label="Print agreement">
                                    <mat-icon style="color: #1C3F8B;">print</mat-icon>
                                </button>
                                <button class="me-1" type="button" mat-stroked-button color="primary" (click)="sendEmailNewEnrollment(this.entityData?.id)">
                                    Email
                                </button>
                            </div>
                            <div class="col-6">
                                <div class="pull-end">
                                    <button
                                    [disabled]="!detectSignatureStudio || !detectSignatureStudent || !tosAccepted || scheduledPaymentsOutOfDate || savingEnrollment"
                                    class="me-1"
                                    type="button"
                                    mat-stroked-button
                                    (click)="onSubmitSignatures('save_and_add')"
                                    color="primary">
                                        Save and Add
                                    </button>
                                    <button
                                    [disabled]="!detectSignatureStudio || !detectSignatureStudent || !tosAccepted || scheduledPaymentsOutOfDate || savingEnrollment"
                                    class="me-1"
                                    type="button"
                                    mat-stroked-button
                                    (click)="onSubmitSignatures('save_and_pay')"
                                    color="primary">
                                        Save and Pay
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </mat-tab>

            <mat-tab [disabled]="this.initActionType != 'create'" label="{{(this.initActionType == 'create' ? 'Create' : 'Edit')}}">
                <mat-stepper [className]="this.initActionType == 'create' ? '' : 'hide-mat-horizontal-stepper-header-container'" [selectedIndex]="this.enrollmentStepperIndex" [linear]="true" [disableRipple]="true" #enrollmentStepper>
                    <mat-step [stepControl]="enrollmentForm">

                        <form *ngIf="enrollmentForm" [formGroup]="enrollmentForm" (ngSubmit)="onSubmitEnrollment(f, stepper)" #f="ngForm" class="form">
                            <ng-template matStepLabel>Enrollment</ng-template>


                            <div class="container">
                                <div class="row">
                                    <input class="d-none" formControlName="title" value="'default'" matInput>
                                    <input class="d-none" formControlName="field_payments_structure_type" value="field_payments_structure_type" matInput>

                                    <app-error-message [message]=this.errorMessage></app-error-message>

                                    <!-- Draft kept when an earlier save couldn't reach the server -->
                                    <div *ngIf="enrollmentDraft" class="col-12 mb-2 mt-2 alert alert-warning d-flex align-items-start" role="alert">
                                        <mat-icon class="me-2 flex-shrink-0">restore</mat-icon>
                                        <div class="flex-grow-1">
                                            <div>Unsaved enrollment for {{ enrollmentDraft.studentName }} from {{ enrollmentDraft.savedAt | date:'MMM d, h:mm a' }}. It was kept on this computer because the server couldn't be reached.</div>
                                            <div *ngIf="enrollmentDraftExistingId" class="mt-1">Enrollment #{{ enrollmentDraftExistingId }} is already on file for this student around the same sale date, so it may have saved after all. Check it before restoring.</div>
                                            <div class="d-flex justify-content-end gap-2 mt-2">
                                                <button type="button" mat-raised-button color="accent" (click)="discardEnrollmentDraft()">Discard</button>
                                                <button type="button" mat-raised-button color="primary" (click)="restoreEnrollmentDraft()">Restore</button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Student Account Autocomplete -->
                                    <div class="col-6">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Student Account</mat-label>
                                            <input
                                                required
                                                name="field_student"
                                                (input)="onAutocompleteStudent($event);"
                                                matInput
                                                formControlName="field_student"
                                                required
                                                #td_student_account
                                                [matAutocomplete]="autoCompleteStudentAccount"
                                                [ngModel]="this._frmValues?.field_student"
                                                >
                                            <button type="button" matSuffix mat-icon-button
                                                aria-label="manage_accounts">
                                                <mat-icon>manage_accounts</mat-icon>
                                            </button>
                                            <mat-error *ngIf="enrollmentForm.get('field_student').hasError('required')">
                                                Student account is required
                                            </mat-error>
                                            <mat-error *ngIf="enrollmentForm.get('field_student').hasError('invalidStudentFormat')">
                                                Please select a student account from the dropdown list
                                            </mat-error>
                                        </mat-form-field>
                                        <mat-autocomplete #autoCompleteStudentAccount="matAutocomplete" (optionSelected)="onAutoCompleteStudentLoadInstructorExecutive($event)">
                                            <mat-option
                                                *ngFor="let option of autoCompleteStudentOptions"
                                                [value]="option.label + ' (' + option.value + ')'">
                                                {{option.label}} ({{option.value}})
                                            </mat-option>
                                        </mat-autocomplete>
                                    </div>

                                    <div class="col-6">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Enrollment Date</mat-label>
                                            <!-- (focus) not (click): both opening paths (clicking the input
                                                 and clicking the suffix icon) focus the input (that focus is
                                                 what opens flatpickr), so one handler covers both. -->
                                            <input formControlName="field_sale_date"
                                                   matInput
                                                   type="text"
                                                   appFlatpickrDatetime
                                                   [enableTime]="true"
                                                   [minuteIncrement]="15"
                                                   (focus)="setSaleDateToStudioNow()"
                                                   readonly>
                                            <mat-icon matSuffix>calendar_today</mat-icon>
                                        </mat-form-field>
                                    </div>

                                    <!-- Package Autocomplete -->
                                    <div class="col-12">
                                        <mat-form-field class="full-width-field">
                                        <mat-label>Package</mat-label>
                                        <input formControlName="field_enrollment_package_name" name="field_enrollment_package_name" (input)="onAutocompletePackages($event);" matInput
                                            [matAutocomplete]="autoCompletePackage">
                                        <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                                            <mat-icon>manage_accounts</mat-icon>
                                        </button>
                                        <mat-error *ngIf="enrollmentForm.get('field_enrollment_package_name').hasError('required')">
                                            Package is required
                                        </mat-error>
                                        <mat-error *ngIf="enrollmentForm.get('field_enrollment_package_name').hasError('invalidPackageFormat')">
                                            Please select a package from the dropdown list
                                        </mat-error>
                                        </mat-form-field>
                                        <mat-autocomplete #autoCompletePackage="matAutocomplete" (optionSelected)="onPackageLookup($event);">
                                        <mat-option *ngFor="let option of autoCompletePackageOptions" [value]="option.label + ' ' + '(' + option.value + ')'">
                                            {{option.label}} ({{option.value}})
                                        </mat-option>
                                        </mat-autocomplete>
                                    </div>

                                    <!-- Category Dropdown -->
                                    <div class="col-12">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Category</mat-label>
                                            <mat-select (selectionChange)="calcNewTotal(); validateDECategoryPrice()" matInput formControlName="field_category" name="field_category">
                                                <mat-option>None</mat-option>
                                                <mat-option *ngFor="let element of this._taxonomyService.enrollment_type"
                                                    [value]="element.id">
                                                    {{ element.name }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <mat-form-field class="full-width-field">
                                                <mat-label>{{getAmountLabel()}}</mat-label>
                                                <input formControlName="field_enrollment_lesson_price" type="number" (change)="calcNewTotal(); validateDECategoryPrice()" name="field_enrollment_lesson_price" matInput>
                                                <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                            </mat-form-field>
                                        </div>

                                        <div [ngClass]="{ 'd-none': isMiscOrSundry  }" class="col-6">
                                            <mat-form-field class="full-width-field">
                                                <mat-label>Lesson Count</mat-label>
                                                <input min="0" type="number" (change)="calcNewTotal()" name="field_enrollment_lesson_count" matInput formControlName="field_enrollment_lesson_count">
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <!-- Discount Type Dropdown -->
                                    <div class="col-6 col-md-3">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Discount Type</mat-label>
                                            <mat-select (ngModelChange)="calcNewTotal()"
                                             matInput
                                             [ngModel]="this._frmValues?.field_discount_type"
                                             formControlName="field_discount_type"
                                             name="field_discount_type">
                                                <mat-option>None</mat-option>
                                                <mat-option
                                                    (optionSelected)="calcNewTotal()"
                                                    *ngFor="let element of this._fieldsService.discountType"
                                                    [value]="element.key">
                                                    {{ element.value }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-6 col-md-3">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Discount</mat-label>
                                            <input [(ngModel)]="this.enrollmentForm.value.field_discount"
                                            min="0"
                                            type="number"
                                            (change)="calcNewTotal()"
                                            name="field_discount"
                                            matInput formControlName="field_discount">
                                            <span *ngIf="this.enrollmentForm.value.field_discount_type == 'flat'" matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                            <span *ngIf="this.enrollmentForm.value.field_discount_type == 'percentage'" matSuffix>&nbsp;%</span>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-6 col-md-2">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Taxes</mat-label>
                                            <input formControlName="field_tax_percentage" type="number" (change)="calcNewTotal()" name="field_tax_percentage" matInput>
                                            <span matSuffix>%&nbsp;</span>
                                        </mat-form-field>
                                    </div>

                                    <!-- This is for the entire enrollment. -->
                                    <input class="d-none" name="field_enrollment_total_price" matInput formControlName="field_enrollment_total_price">
                                    <div class="col-12 col-md-4 mb-4 mb-md-1">
                                        <mat-form-field appearance="fill" class="full-width-field">
                                            <mat-label>Total Investment</mat-label>
                                            <input readonly name="field_total_price_with_est_tax" matInput formControlName="field_total_price_with_est_tax">
                                            <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                            <mat-hint *ngIf="!isTaxInclusive">({{this.enrollmentForm.get("field_tax_percentage").value | number:'1.0-3'}}% estimated tax and {{this.enrollmentForm.get("field_discount").value | studioCurrency}} discount is calculated.)</mat-hint>
                                            <mat-hint *ngIf="isTaxInclusive">(Total includes {{getTaxTypeLabel()}} {{this.enrollmentForm.get("field_taxes").value | studioCurrency}}. Discount: {{this.enrollmentForm.get("field_discount").value | studioCurrency}})</mat-hint>
                                        </mat-form-field>
                                    </div>

                                    <div class="mt-3"></div>

                                    <div class="col-3 d-none">
                                        <mat-form-field appearance="fill" class="full-width-field">
                                            <mat-label>Total Lesson Price</mat-label>
                                            <input readonly name="field_total_lessons_price" matInput formControlName="field_total_lessons_price">
                                            <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <!-- <div class="row">
                                    <div class="col-4">
                                        <mat-form-field appearance="fill" class="full-width-field">
                                            <mat-label>Total Paid</mat-label>
                                            <input readonly name="field_total_paid" matInput formControlName="field_total_paid">
                                        </mat-form-field>
                                    </div>
                                </div> -->
                            </div>

                            <div class="container">
                                <div class="row">

                                        <div class="col-6 d-none">
                                            <mat-form-field appearance="fill" class="full-width-field">
                                                <mat-label>Lesson Used</mat-label>
                                                <input readonly name="field_lesson_used" matInput formControlName="field_lesson_used">
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6 d-none">
                                            <mat-form-field appearance="fill" class="full-width-field">
                                                <mat-label>Lesson Paid</mat-label>
                                                <input readonly name="field_lessons_paid" matInput formControlName="field_lessons_paid">
                                            </mat-form-field>
                                        </div>

                                        <div class="col-6 d-none">
                                            <mat-form-field appearance="fill" class="full-width-field">
                                                <mat-label>Lesson Available</mat-label>
                                                <input readonly name="field_lesson_available" matInput formControlName="field_lesson_available">
                                            </mat-form-field>
                                        </div>
                                </div>
                            </div>

                            <div *ngIf="studentBalanceWarning" class="col-12 mb-2 mt-2 alert alert-warning d-flex align-items-start" role="alert">
                                <mat-icon class="me-2 flex-shrink-0">warning</mat-icon>
                                <span>{{ studentBalanceWarning }}</span>
                            </div>

                            <div *ngIf="deCategoryPriceWarning" class="col-12 mb-2 mt-2 alert alert-warning d-flex align-items-start" role="alert">
                                <mat-icon class="me-2 flex-shrink-0">warning</mat-icon>
                                <span>{{ deCategoryPriceWarning }}</span>
                            </div>

                            <div class="container mb-2">
                                <div class="row">
                                    <div style="border: 1px solid rgb(204, 204, 204); padding: 13px; border-radius: 10px;">
                                        <h3>Scheduled Payments</h3>

                                        <div class="row mb-3">
                                            <mat-radio-group [ngModel]="this._frmValues?.field_payments_structure" class="row" formControlName="field_payments_structure" aria-label="Select an option">
                                                <div class="col-6 col-sm-3">
                                                    <mat-radio-button (click)="paid_in_full()" value="paid_in_full">Pay In Full</mat-radio-button>
                                                </div>
                                                <div class="col-6 col-sm-3">
                                                    <mat-radio-button (click)="use_installments()" value="installments">Installments</mat-radio-button>
                                                </div>
                                            </mat-radio-group>

                                            <div *ngIf="is_use_installments && (this.actionType == 'create' || this.actionType == 'editEnrollment' || this.actionType == 'edit')" class="col-12 mb-1 mt-1">
                                                <div class="mb-2 mt-2 d-flex flex-wrap align-items-center gap-2">
                                                    <div class="btn-group flex-wrap" role="group">
                                                        <button type="button" class="btn btn-outline-primary"
                                                            (click)="onPaymentStructureTypeChange('weekly')"
                                                            [class.active]="enrollmentForm.get('field_payments_structure_type').value == 'weekly'">
                                                            Weekly
                                                        </button>
                                                        <button type="button" class="btn btn-outline-primary"
                                                            (click)="onPaymentStructureTypeChange('monthly')"
                                                            [class.active]="enrollmentForm.get('field_payments_structure_type').value == 'monthly'">
                                                            Monthly
                                                        </button>
                                                        <button type="button" class="btn btn-outline-primary"
                                                            (click)="onPaymentStructureTypeChange('by_the_lesson')"
                                                            [class.active]="enrollmentForm.get('field_payments_structure_type').value == 'by_the_lesson'">
                                                            By The Lesson
                                                        </button>
                                                    </div>
                                                </div>

                                                <!-- Optional down payment / initial investment. Subtracted from the
                                                     total; the remainder is split across the installments below. -->
                                                <div class="mb-2 col-12 col-sm-6 col-md-4"
                                                     [ngClass]="{ 'd-none': enrollmentForm.get('field_payments_structure_type').value != 'monthly' && enrollmentForm.get('field_payments_structure_type').value != 'weekly' }">
                                                    <mat-form-field class="full-width-field">
                                                        <mat-label>Down Payment / Initial Investment{{ scheduledRowsShowTotal ? ' (incl. tax)' : '' }}</mat-label>
                                                        <input min="0" type="number" matInput formControlName="field_down_payment_amount" name="field_down_payment_amount">
                                                        <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                                        <mat-hint>Optional: leave blank to split the full total</mat-hint>
                                                    </mat-form-field>
                                                </div>

                                                <!-- Monthly/weekly: split the remainder into a number of payments
                                                     (default) or into payments of an amount the student agreed to,
                                                     the last payment taking whatever is left. -->
                                                <mat-radio-group formControlName="installment_split_mode" class="d-flex flex-wrap gap-3 mb-1"
                                                    *ngIf="enrollmentForm.get('field_payments_structure_type').value == 'monthly' || enrollmentForm.get('field_payments_structure_type').value == 'weekly'">
                                                    <mat-radio-button value="count">Number of payments</mat-radio-button>
                                                    <mat-radio-button value="amount">Payment amount</mat-radio-button>
                                                </mat-radio-group>

                                                <div class="d-flex flex-wrap align-items-center gap-1">
                                                    <ng-container [ngSwitch]="enrollmentForm.get('field_payments_structure_type').value">
                                                        <span *ngSwitchCase="'weekly'">{{ installmentSentenceStart }}</span>
                                                        <span *ngSwitchCase="'monthly'">{{ installmentSentenceStart }}</span>
                                                        <span *ngSwitchCase="'by_the_lesson'">Payments due every </span>
                                                        <span *ngSwitchDefault></span>
                                                    </ng-container>
                                                    <mat-form-field *ngIf="!splitByAmount" [ngClass]="{ 'd-none' : enrollmentForm.get('field_payments_structure_type').value == null}" style="width:50px" class="ms-1 me-1">
                                                        <input min="0" formControlName="interval" matInput type="number">
                                                    </mat-form-field>
                                                    <mat-form-field *ngIf="splitByAmount" style="width:150px" class="ms-1 me-1">
                                                        <mat-label>Amount{{ scheduledRowsShowTotal ? ' (incl. tax)' : '' }}</mat-label>
                                                        <input min="0" formControlName="installment_amount" matInput type="number">
                                                        <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                                    </mat-form-field>
                                                    <ng-container [ngSwitch]="enrollmentForm.get('field_payments_structure_type').value">
                                                        <span *ngSwitchCase="'weekly'">{{ splitByAmount ? 'each, the last payment taking whatever is left,' : 'payments' }}</span>
                                                        <span *ngSwitchCase="'monthly'">{{ splitByAmount ? 'each, the last payment taking whatever is left,' : 'payments' }}</span>
                                                        <span *ngSwitchCase="'by_the_lesson'">lessons</span>
                                                        <span *ngSwitchDefault></span>
                                                    </ng-container>
                                                    <span [ngClass]="{ 'd-none': interval != 'monthly' }">
                                                        payments months on the
                                                        <mat-form-field class="ms-1" style="width:180px">
                                                            <mat-label>Select Day</mat-label>
                                                            <mat-select
                                                            matInput
                                                            formControlName="field_recurrent_month_day">
                                                                <mat-option>None</mat-option>
                                                                <mat-option
                                                                    *ngFor="let element of this._fieldsService.dayDropdownSimple"
                                                                    [value]="element.value.toString()">
                                                                    {{ element.name }}</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </span>
                                                    <span [ngClass]="">
                                                        <ng-container [ngSwitch]="enrollmentForm.get('field_payments_structure_type').value">
                                                            <span *ngSwitchCase="'weekly'"> starting on the</span>
                                                            <span *ngSwitchCase="'monthly'"> starting on the</span>
                                                            <span *ngSwitchCase="'by_the_lesson'">. Start on</span>
                                                            <span *ngSwitchDefault></span>
                                                        </ng-container>
                                                        <mat-form-field [ngClass]="{ 'd-none' : enrollmentForm.get('field_payments_structure_type').value == null}" class="ms-1 full-width-field" style="width:130px">
                                                            <mat-label>Select Day</mat-label>
                                                            <input formControlName="field_recurrent_month_day"
                                                                   matInput
                                                                   type="text"
                                                                   appFlatpickrDatetime
                                                                   [enableTime]="false"
                                                                   readonly>
                                                            <mat-icon matSuffix>calendar_today</mat-icon>
                                                        </mat-form-field>
                                                        <mat-icon
                                                            [ngClass]="{
                                                                'd-none': !(enrollmentForm.get('field_payments_structure_type').value == 'monthly' && enrollmentForm.get('field_payments_structure_type').value != '')
                                                            }"
                                                            class="ms-2 cursor-pointer"
                                                            (click)="paymentPlanGeneratorIncreaseStep(i)"
                                                            aria-hidden="false"
                                                            aria-label="trash">add_box</mat-icon>
                                                    </span>
                                                </div>

                                                <div>
                                                    <ng-container *ngIf="enrollmentForm.get('payment_builder_date_step').controls">
                                                        <div formArrayName="payment_builder_date_step">
                                                            <div *ngFor="let instructorControl of enrollmentForm.get('payment_builder_date_step').controls; let i = index">
                                                                <div [formGroupName]="i" class="row">

                                                                    <div>
                                                                        <span [ngClass]="">
                                                                            Add additional payment on the
                                                                            <mat-form-field class="ms-1" style="width:125px">
                                                                                <mat-label>Select Day</mat-label>
                                                                                <mat-select
                                                                                matInput
                                                                                formControlName="field_recurrent_month_day">
                                                                                    <mat-option>None</mat-option>
                                                                                    <mat-option
                                                                                        *ngFor="let element of this._fieldsService.dayDropdown"
                                                                                        [value]="element.value">
                                                                                        {{ element.name }}</mat-option>
                                                                                </mat-select>
                                                                            </mat-form-field>
                                                                            <mat-icon
                                                                                *ngIf="this.actionType == 'create' || this.actionType == 'editEnrollment' || this.actionType == 'edit'"
                                                                                class="ms-2 cursor-pointer"
                                                                                (click)="paymentPlanGeneratorRemoveStep(i)"
                                                                                aria-hidden="false"
                                                                                aria-label="trash">cancel</mat-icon>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </div>

                                                <!-- Separate into
                                                <mat-form-field style="width:50px" class="ms-1 me-1">
                                                    <input min="0" formControlName="scheduled_payments_min_payment" matInput type="number">
                                                </mat-form-field> -->

                                                <div [ngClass]="{ 'd-none': enrollmentForm.get('field_payments_structure_type').value != 'weekly' }">
                                                    <div class="mt-1 mb-3">
                                                        <section class="example-section d-flex flex-wrap gap-2">
                                                            <!-- <mat-checkbox *ngFor="let day of daysOfWeek" ngModel name="{{day}}"
                                                                [value]="day"
                                                                class="example-margin">{{day}}</mat-checkbox> -->
                                                            <mat-checkbox formControlName="field_recurrent_weekday_su" name="field_recurrent_weekday_su" class="example-margin">Sun</mat-checkbox>
                                                            <mat-checkbox formControlName="field_recurrent_weekday_mo" name="field_recurrent_weekday_mo" class="example-margin">Mon</mat-checkbox>
                                                            <mat-checkbox formControlName="field_recurrent_weekday_tu" name="field_recurrent_weekday_tu" class="example-margin">Tue</mat-checkbox>
                                                            <mat-checkbox formControlName="field_recurrent_weekday_we" name="field_recurrent_weekday_we" class="example-margin">Wed</mat-checkbox>
                                                            <mat-checkbox formControlName="field_recurrent_weekday_th" name="field_recurrent_weekday_th" class="example-margin">Thu</mat-checkbox>
                                                            <mat-checkbox formControlName="field_recurrent_weekday_fr" name="field_recurrent_weekday_fr" class="example-margin">Fri</mat-checkbox>
                                                            <mat-checkbox formControlName="field_recurrent_weekday_sa" name="field_recurrent_weekday_sa" class="example-margin">Sat</mat-checkbox>
                                                        </section>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <!-- Out-of-date warning sits next to the Generate button so the
                                             "regenerate" call-to-action is right here. -->
                                        <div *ngIf="scheduledPaymentsOutOfDate" class="alert alert-warning mb-3 d-flex align-items-start" role="alert">
                                            <mat-icon class="me-2 flex-shrink-0">warning</mat-icon>
                                            <span>
                                                <strong>Warning:</strong> Your scheduled payments are out of date. Please regenerate the payment plan after changing the payment structure, lesson price, count, discount, or tax percentage.
                                            </span>
                                        </div>

                                        <!-- Generate sits next to its output: just above the payment rows.
                                             Full-width on mobile (d-grid), auto width on desktop (d-md-block). -->
                                        <div *ngIf="is_use_installments && (this.actionType == 'create' || this.actionType == 'editEnrollment' || this.actionType == 'edit')"
                                             class="d-grid d-md-block mb-3">
                                            <button type="button" class="btn btn-primary" (click)="calcScheduledPayments()">
                                                Generate Payment Plan
                                            </button>
                                        </div>

                                        <ng-container *ngIf="enrollmentForm.get('field_scheduled_payments').controls">
                                            <div formArrayName="field_scheduled_payments">
                                                <div *ngFor="let paymentControl of (enrollmentForm.get('field_scheduled_payments')).controls; let i = index"
                                                     class="border rounded p-3 mb-3"
                                                     [ngClass]="{ 'border-primary bg-light': paymentControl.get('field_down_payment')?.value === true && enrollmentForm.get('field_payments_structure')?.value != 'paid_in_full' }">
                                                    <div [formGroupName]="i" class="row align-items-center">

                                                        <input class="d-none" formControlName="id" value="id" matInput>
                                                        <input class="d-none" formControlName="type" name="type" value="scheduled_payments" matInput>
                                                        <input class="d-none" formControlName="bundle" name="bundle" value="scheduled_payments" matInput>
                                                        <input class="d-none" formControlName="field_studio_reference" name="field_studio_reference" value="field_studio_reference" matInput>

                                                        <!-- Per-payment header: label + inline remove -->
                                                        <div class="col-12 d-flex align-items-center justify-content-between mb-2">
                                                            <span class="fw-semibold"
                                                                  [ngClass]="(paymentControl.get('field_down_payment')?.value === true && enrollmentForm.get('field_payments_structure')?.value != 'paid_in_full') ? 'text-primary' : 'text-muted'">
                                                                {{ scheduledPaymentLabel(i) }}
                                                            </span>
                                                            <mat-icon
                                                                *ngIf="this.actionType == 'create' || this.actionType == 'edit' || this.actionType == 'editEnrollment'"
                                                                class="cursor-pointer text-muted"
                                                                (click)="scheduledPaymentRemove(i)"
                                                                aria-hidden="false"
                                                                aria-label="Remove payment">cancel</mat-icon>
                                                        </div>

                                                        <div class="col-12" [ngClass]="scheduledRowsShowTotal ? 'col-md-3' : 'col-md-4'">
                                                            <mat-form-field class="full-width-field">
                                                                <mat-label>Payment Amount</mat-label>
                                                                <input min="0" type="number" formControlName="field_payment_amount" name="percentage" matInput (input)="calculateTax(i)" [readonly]="enrollmentForm.get('field_payments_structure').value == 'paid_in_full'" [style.cursor]="enrollmentForm.get('field_payments_structure').value == 'paid_in_full' ? 'not-allowed' : 'auto'">
                                                                <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="col-12" [ngClass]="scheduledRowsShowTotal ? 'col-md-2' : 'col-md-3'">
                                                            <mat-form-field class="full-width-field">
                                                              <mat-label>Tax Amount</mat-label>
                                                              <input type="text" formControlName="field_tax_amount" readonly matInput>
                                                              <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                                            </mat-form-field>
                                                          </div>

                                                        <div *ngIf="scheduledRowsShowTotal" class="col-12 col-md-3">
                                                            <mat-form-field class="full-width-field">
                                                                <mat-label>Total (incl. tax)</mat-label>
                                                                <input min="0" type="number"
                                                                    [value]="scheduledRowTotal(i)"
                                                                    (change)="onScheduledTotalEntered(i, $any($event.target).value)"
                                                                    matInput
                                                                    [readonly]="enrollmentForm.get('field_payments_structure').value == 'paid_in_full'"
                                                                    [style.cursor]="enrollmentForm.get('field_payments_structure').value == 'paid_in_full' ? 'not-allowed' : 'auto'">
                                                                <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="col-12 col-md-4"
                                                        [ngClass]="{
                                                            'd-none': (enrollmentForm.get('field_payments_structure_type').value == 'by_the_lesson')
                                                        }">
                                                            <mat-form-field class="full-width-field">
                                                                <mat-label>Payment Date</mat-label>
                                                                <input formControlName="field_payment_date"
                                                                       matInput
                                                                       type="text"
                                                                       appFlatpickrDatetime
                                                                       [enableTime]="true"
                                                                       [minuteIncrement]="15"
                                                                       readonly>
                                                                <mat-icon matSuffix>calendar_today</mat-icon>
                                                            </mat-form-field>
                                                        </div>
                                                        <div [ngClass]="{
                                                            'd-none': enrollmentForm.get('field_payments_structure').value != 'installments'
                                                            || enrollmentForm.get('field_payments_structure_type').value != 'by_the_lesson'
                                                            || (this.initActionType != 'create' && this.initActionType != 'edit' && this.initActionType != 'editEnrollment')
                                                            }" class="col-12 col-md-3">
                                                            <mat-form-field class="full-width-field">
                                                                <mat-label>Due At</mat-label>
                                                                <input min="0" type="number" formControlName="field_number_lesson_remaining" name="field_number_lesson_remaining" matInput>
                                                                <span matPrefix>#&nbsp;</span>
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="col-4 d-none">
                                                            <mat-form-field class="full-width-field">
                                                                <mat-label>Amount Paid</mat-label>
                                                                <input min="0" type="number" formControlName="field_amount_paid" name="field_amount_paid" matInput>
                                                                <span matPrefix>{{ '' | studioCurrencySymbol }}&nbsp;</span>
                                                            </mat-form-field>
                                                        </div>

                                                        <div class="col-3 d-none">
                                                            <mat-checkbox formControlName="field_paid_in_full" name="field_paid_in_full" class="example-margin">Paid In Full</mat-checkbox>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <!-- [disabled]="!enrollmentForm.get('field_scheduled_payments').valid" -->
                                        <button *ngIf="!is_pay_in_full && enrollmentForm.get('field_payments_structure').value != 'paid_in_full' && (this.actionType == 'create' || this.actionType == 'edit' || this.actionType == 'editEnrollment')" type="button"
                                            mat-raised-button
                                            class="me-1"
                                            color="primary" (click)="scheduledPaymentIncrement()">
                                            Add Scheduled Payment
                                        </button>
                                    </div>
                                </div>
                            </div>



                                <div class="container">
                                    <div class="row">

                                    <!-- <div class="col-12">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Expiration Date</mat-label>
                                            <input
                                                matInput
                                                [matDatepicker]="pickerFieldExpirationDate"
                                                required
                                                name="field_expiration_date"
                                                formControlName="field_expiration_date"
                                                >
                                            <mat-datepicker-toggle matSuffix [for]="pickerFieldExpirationDate"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerFieldExpirationDate></mat-datepicker>
                                        </mat-form-field>
                                    </div> -->

                                    <div class="col-12">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Expiration Date</mat-label>
                                            <input formControlName="field_expiration_date"
                                                   matInput
                                                   type="text"
                                                   appFlatpickrDatetime
                                                   [enableTime]="true"
                                                   [minuteIncrement]="15"
                                                   readonly>
                                            <mat-icon matSuffix>calendar_today</mat-icon>
                                        </mat-form-field>
                                    </div>

                                    <!-- {{this.enrollmentForm.value | json}} -->

                                    <!-- Executive Dropdown -->
                                    <div class="col-12">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Executive</mat-label>
                                            <mat-select required matInput formControlName="field_executive" name="field_executive">
                                                <mat-option>None</mat-option>
                                                <ng-container *ngFor="let element of _fieldsService.instructorData(); let i = index">
                                                    <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_executive)"
                                                                [value]="element.uid">
                                                        {{ element.value }}
                                                        <ng-container *ngIf="element.status === '0' && element.uid === field_executive"></ng-container>
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Junior Executive Dropdown -->
                                    <!-- <div class="col-4">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Junior Executive</mat-label>
                                            <mat-select required matInput formControlName="field_junior_executive" name="field_junior_executive">
                                                <mat-option>None</mat-option>
                                                <mat-option *ngFor="let element of this._fieldsService.instructorsJuniorExecutive();"
                                                    [value]="element.uid">
                                                    {{ element.value }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div> -->

                                    <!-- Instructor List -->
                                    <!-- <app-display-instructors
                                    [field_students]="field_student"
                                    [studentUpdateLoad]="studentUpdateLoad"
                                    [studentRemove]="studentRemove"></app-display-instructors> -->

                                    <div formArrayName="field_instructor_percentages" style="border: 1px solid rgb(204, 204, 204); padding: 13px; border-radius: 10px;">
                                        <h3>Instructor Percentage</h3>
                                        <!-- {{this._frmValues?.field_instructor_percentages | json}} -->
                                        <ng-container *ngIf="enrollmentForm.get('field_instructor_percentages').controls">
                                            <div *ngFor="let instructorControl of (enrollmentForm.get('field_instructor_percentages'))?.controls; let i = index">
                                                <div [formGroupName]="i" class="row">

                                                    <input class="d-none" formControlName="id" value="id" matInput>
                                                    <input class="d-none" formControlName="type" value="instructor_percentages" matInput>
                                                    <input class="d-none" formControlName="bundle" value="instructor_percentages" matInput>

                                                    <div class="col-8">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>Instructor</mat-label>
                                                            <mat-select required matInput formControlName="field_instructor" name="instructor">
                                                                <mat-option>None</mat-option>
                                                                <ng-container *ngFor="let element of _fieldsService.instructorData(); let i = index">
                                                                    <mat-option *ngIf="element.status !== '0' || (element.status === '0' && element.uid === field_instructor)"
                                                                                [value]="element.uid">
                                                                        {{ element.value }}
                                                                        <ng-container *ngIf="element.status === '0' && element.uid === field_instructor"></ng-container>
                                                                    </mat-option>
                                                                </ng-container>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-3">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>Percentage</mat-label>
                                                            <input (ngModelChange)="fromPercentCalcTotal()" min="0" max="100" type="number" formControlName="field_percentage" name="field_percentage" matInput>
                                                            <span matSuffix>&nbsp;%</span>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-3 d-none">
                                                        <mat-form-field class="full-width-field">
                                                            <mat-label>Amount</mat-label>
                                                            <input min="0" type="number" formControlName="field_amount" name="field_amount" matInput>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <div>
                                                            <mat-icon
                                                                class="me-2 mt-2"
                                                                *ngIf="this.actionType == 'create' || this.actionType == 'edit' || this.initActionType == 'editEnrollment'"
                                                                (click)="instructorPercentageRemove(i)"
                                                                aria-hidden="false"
                                                                aria-label="trash">cancel</mat-icon>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <!-- [disabled]="!enrollmentForm.get('field_instructor_percentages').valid" -->
                                        <button *ngIf="!instructorPercentageEditMode" type="button"
                                            mat-raised-button
                                            class="me-1"
                                            color="primary" (click)="instructorPercentageIncrement()">
                                            Add Instructor Percentage
                                        </button>

                                    </div>
                                    <div *ngIf="actionType === 'create' && enrollmentForm.get('field_instructor_percentages').value.length === 0" class="text-danger">
                                        * Please add at least one instructor percentage.
                                    </div>

                                    <div class="col-12">
                                        <button *ngIf="instructorPercentageEditMode" type="button"
                                            mat-raised-button
                                            [disabled]="!enrollmentForm.get('field_instructor_percentages').valid"
                                            class="me-1"
                                            color="primary" (click)="studentUpdateSubmit(i, instructor.value)">
                                            Edit Instructor Percentage
                                        </button>
                                    </div>

                                    <div class="col-12 mt-1">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Notes</mat-label>
                                            <textarea formControlName="field_notes" [ngModel]="this._frmValues?.field_notes" name="field_notes"
                                                matInput placeholder=""></textarea>
                                        </mat-form-field>
                                    </div>

                                    <!-- <div class="col-6">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Interval Unit </mat-label>
                                            <mat-select matInput formControlName="field_interval_unit" name="field_interval_unit">
                                                <mat-option>None</mat-option>
                                                <mat-option value="Day">Days</mat-option>
                                                <mat-option value="Weeks">Weeks</mat-option>
                                                <mat-option value="Months">Months</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div> -->

                                    <!-- <div class="col-6">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Enrollment Status</mat-label>
                                            <mat-select matInput formControlName="field_enrollment_status" name="field_enrollment_status">
                                                <mat-option value="_none">None</mat-option>
                                                <mat-option value="Open">Open</mat-option>
                                                <mat-option value="Close">Closed</mat-option>
                                                <mat-option value="Dropped">Dropped</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div> -->

                                    <!-- <div class="col-12">
                                        <mat-form-field class="full-width-field">
                                            <mat-label>Next Scheduled Payment</mat-label>
                                            <input
                                            matInput
                                            [matDatepicker]="pickerFieldNextScheduledPayment"
                                            name="field_next_scheduled_payment"
                                            formControlName="field_next_scheduled_payment"
                                            >
                                            <mat-datepicker-toggle matSuffix [for]="pickerFieldNextScheduledPayment"></mat-datepicker-toggle>
                                            <mat-datepicker #pickerFieldNextScheduledPayment></mat-datepicker>
                                        </mat-form-field>
                                    </div> -->

                                    <div class="col-12 d-none">
                                        <mat-checkbox
                                        formControlName="field_visibility"
                                        name="field_visibility"
                                        class="">Hidden</mat-checkbox>

                                        <mat-checkbox
                                        formControlName="field_draft"
                                        name="field_draft"
                                        class="">Draft</mat-checkbox>

                                    </div>

                                    <div class="mt-4">
                                      <!-- Button for creating enrollment. -->
                                      <button
                                      *ngIf="this.initActionType == 'create'"
                                      [disabled]="!enrollmentForm.valid || !enrollmentForm.get('field_instructor_percentages').value.length > 0 || studentBalanceWarning || deCategoryPriceWarning || scheduledPaymentsOutOfDate" (click)="onSubmitEnrollment(f, 'create')" type="button" mat-button>Next</button>

                                      <!-- Button for editing enrollment. -->
                                      <button
                                      *ngIf="this.initActionType == 'editEnrollment'"
                                       [disabled]="!enrollmentForm.valid || deCategoryPriceWarning || scheduledPaymentsOutOfDate" (click)="onSubmitEnrollment(f, 'edit')" type="button" color="primary" mat-button>Save</button>
                                    </div>


                                    <!-- <p>Form value: {{ enrollmentForm.value | json }}</p>
                                    <p>Form status: {{ enrollmentForm.status | json }}</p>

                                    {{getFormErrors(this.enrollmentForm) | json}} -->

                                </div>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="agreementFormGroup" label="Agreement">
                      <form [formGroup]="agreementFormGroup">

                        <input class="d-none" formControlName="field_nothing">
                        <!-- <input formControlName="firstName"> -->

                        <app-enrollment-agreement-display
                            [entityData]="enrollmentEntityData"
                            [studentAccountEntityData]="studentAccountEntityData"
                            [studioInformationConfig]="studioInformationConfig"
                            [enrollmentForm]="enrollmentForm"
                            [displaySignatures]="true"
                            [displayPrintButton]="true"
                            [displayEmailButton]="true"
                            [displaySigned]="false"
                            [displayBottomStudioInfo]="false"
                            [isTaxInclusive]="isTaxInclusive"
                            [taxConfig]="taxConfig"
                            [templateKey]="activeTemplateKey"
                        ></app-enrollment-agreement-display>

                        <div>
                            <div class="container">
                                <div class="border border-dark bg-secondary bg-opacity-10 p-4 rounded mt-3">
                                                                        <mat-checkbox
                                        [checked]="tosAccepted"
                                        (change)="updateTosAcceptedDate($event)"
                                        color="primary"
                                        class="">
                                        <div style="white-space: normal; word-wrap: break-word;">
                                            <ng-container [ngSwitch]="activeTemplateKey">
                                                <ng-container *ngSwitchCase="'amdc_italian'">
                                                    I have read and agree to this agreement, including the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Condizioni Generali del Servizio</a>.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_sydney_premium'">
                                                    I have read and agree to this agreement, including the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Premium Dance Program Enrolment Agreement</a>.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_winnipeg'">
                                                    I have read and agree to this agreement, including the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms and Conditions</a>, and acknowledge that they form part of this agreement.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_alberta'">
                                                    I have read and agree to this agreement, including the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Waiver of Liability</a>.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_ontario'">
                                                    I have read and agree to this agreement, including the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms and Conditions</a>, and acknowledge that they form part of this agreement.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_bc'">
                                                    I have read and agree to this agreement, including the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms and Conditions</a>.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_quebec'">
                                                    J'ai lu et j'accepte le pr&eacute;sent contrat, y compris les <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">conditions et extraits de la Loi sur la protection du consommateur</a> ci-joints.
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'amdc_standard'">
                                                    This agreement is subject to and will be governed by the Terms of Service, which are incorporated in this agreement by reference.
                                                    By executing this agreement, you acknowledge that you have read the Terms of Service and agree to abide by them.
                                                    All references to "this agreement" mean this agreement together with the attached <a class="cursor-pointer text-primary fw-bold" (click)="printPage(true, false)">Terms of Service</a>.
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    I have read and agree to this agreement.
                                                </ng-container>
                                            </ng-container>
                                            <!-- <span class="text-danger">*</span> -->
                                        </div>
                                    </mat-checkbox>
                                </div>

                                <div style="min-height: 20px;">
                                    <div *ngIf="tosAccepted" class="mt-2 ps-4 text-success fst-italic small">
                                        <i class="fas fa-check-circle me-1"></i> Terms of Service accepted on {{ (entityData?.field_tos_accepted_date || enrollmentForm.get('field_tos_accepted_date')?.value) | date:'MMM d, y, h:mm a':'local' }}
                                    </div>

                                    <div *ngIf="!tosAccepted && (detectSignatureStudio || detectSignatureStudent)" class="mt-2 ps-4 text-danger fst-italic small">
                                        <i class="fas fa-exclamation-circle me-1"></i> You must accept the Terms of Service to proceed
                                    </div>
                                </div>
                            </div>

                            <div class="row mt-5 mb-4">
                                <div class="col-12">
                                    <h4 class="fw-bold mb-3 pb-2 border-bottom">Signatures</h4>
                                    <div class="row g-4">
                                        <div class="col-12 col-lg-6">
                                            <div class="signature-box p-3 border rounded">
                                                <p class="fw-bold mb-2">Studio Representative:</p>
                                                <div class="signature-container bg-light p-1 border rounded" style="min-height: 125px; touch-action: none;">
                                                    <canvas width="441" height="125" class="signature-canvas w-100" #SignatureStudio></canvas>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center mt-2">
                                                    <button class="mt-1 display-none" type="button" mat-stroked-button (click)="signatureClearStudio()">Clear</button>
                                                    <p class="mb-0 text-end"><span class="fw-bold">Date:</span> {{ this.entityData?.['field_sale_date'] | date }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-6">
                                            <div class="signature-box p-3 border rounded">
                                                <p class="fw-bold mb-2">Client Signature:</p>
                                                <div class="signature-container bg-light p-1 border rounded" style="min-height: 125px; touch-action: none;">
                                                    <canvas width="441" height="125" class="signature-canvas w-100" #SignatureStudent></canvas>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center mt-2">
                                                    <button class="mt-1 display-none" type="button" mat-stroked-button (click)="signatureClearStudent()">Clear</button>
                                                    <p class="mb-0 text-end"><span class="fw-bold">Date:</span> {{ this.entityData?.['field_sale_date'] | date }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-4">
                                        <div class="col-12">
                                            <div class="parent-signature p-3 border rounded bg-light" [class.d-none]="!detectSignatureParent">
                                                <p class="fw-bold mb-2">Parent/Guardian Signature (if applicable):</p>
                                                <div class="signature-container bg-light p-1 border rounded" style="min-height: 125px; touch-action: none;">
                                                    <canvas width="888" height="125" class="signature-canvas w-100" #SignatureParent></canvas>
                                                </div>
                                                <div class="d-flex justify-content-between align-items-center mt-2">
                                                    <button class="mt-1" [class.display-none]="!detectSignatureParent" type="button" mat-stroked-button (click)="signatureClearParent()">Clear</button>
                                                    <p class="mb-0 text-end"><span class="fw-bold">Date:</span> {{ this.entityData?.['field_sale_date'] | date }}</p>
                                                </div>
                                                <p class="small text-muted mt-2 mb-0">On behalf of my minor child and myself, I agree to assume and comply with all the provisions of this agreement, including the provision titled "Participation & Assumption of Risk" and "Indemnity." I promise to pay any financial obligation that my minor child does not pay for any reason.</p>
                                            </div>

                                            <!-- Optional, opt-in: only shown for enrollments involving a minor.
                                                 Kept low-emphasis (outlined, icon-prefixed) so it doesn't
                                                 compete with the primary Save actions. Full-width tap target
                                                 on mobile, auto-width on desktop. -->
                                            <div *ngIf="!detectSignatureParent" class="d-grid d-lg-block mt-2">
                                                <button type="button" mat-stroked-button (click)="showParentSignature()">
                                                    <mat-icon>person_add</mat-icon>
                                                    Add Parent/Guardian Signature
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div id="enrollment-agreement-backpage" class="page2">
                            <div [innerHTML]="backpageHtmlContent"></div>
                        </div>

                        <!-- Validation message: full-width and placed directly above the action
                             bar so the user sees what's blocking the (disabled) Save buttons
                             before reaching for them. -->
                        <div class="row mt-3" *ngIf="scheduledPaymentsOutOfDate || (detectSignatureStudio !== detectSignatureStudent) || ((detectSignatureStudio || detectSignatureStudent) && !tosAccepted)">
                            <div class="col-12">
                                <div class="alert alert-warning mb-0">
                                    <strong>Please complete the following before proceeding:</strong>
                                    <ul class="mb-0 mt-2">
                                        <li *ngIf="detectSignatureStudio && !detectSignatureStudent">Student signature is required</li>
                                        <li *ngIf="!detectSignatureStudio && detectSignatureStudent">Studio signature is required</li>
                                        <li *ngIf="!tosAccepted">Terms of Service must be accepted</li>
                                        <li *ngIf="scheduledPaymentsOutOfDate">Scheduled payments are out of date - please regenerate payment plan</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- Action bar: primary Save actions are emphasized (filled) and appear
                             first on mobile; Back is low-emphasis navigation and the optional
                             Print/Email are demoted to icon-only utility buttons. -->
                        <div class="row mt-3 g-3 flex-column-reverse flex-lg-row align-items-lg-center">
                            <div class="col-12 col-lg-6">
                                <div class="d-flex align-items-center gap-2">
                                    <button type="button" mat-button matStepperPrevious>
                                        <mat-icon>arrow_back</mat-icon> Back
                                    </button>
                                    <span class="flex-grow-1"></span>
                                    <button style="background-color: transparent !important; border: none;"
                                        (click)="printPage(false, true)"
                                        type="button"
                                        mat-icon-button
                                        class="mb-1"
                                        matTooltip="Print agreement"
                                        matTooltipPosition="below"
                                        aria-label="Print agreement">
                                        <mat-icon style="color: #1C3F8B;">print</mat-icon>
                                    </button>
                                    <button type="button" mat-button color="primary" [disabled]="savingEnrollment" matTooltip="Save the enrollment, then email the agreement" aria-label="Save and email agreement" (click)="onSubmitSignatures('save_and_email')">
                                        <mat-icon>email</mat-icon> Save &amp; Email
                                    </button>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6">
                                <div class="d-grid d-lg-flex gap-2 justify-content-lg-end">
                                    <button
                                    [disabled]="!detectSignatureStudio || !detectSignatureStudent || !tosAccepted || scheduledPaymentsOutOfDate || savingEnrollment"
                                    type="button"
                                    mat-flat-button
                                    (click)="onSubmitSignatures('save_and_pay')"
                                    color="primary">
                                        Save and Pay
                                    </button>
                                    <button
                                    [disabled]="scheduledPaymentsOutOfDate || (detectSignatureStudio !== detectSignatureStudent) || ((detectSignatureStudio || detectSignatureStudent) && !tosAccepted) || savingEnrollment"
                                    type="button"
                                    mat-flat-button
                                    (click)="onSubmitSignatures('save_and_add')"
                                    color="primary">
                                        Save and Add
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="mt-3">
                          <button class="me-1" mat-button matStepperPrevious>Back</button>
                          <button mat-button matStepperNext>Next</button>
                        </div> -->
                      </form>
                    </mat-step>

                    <mat-step [stepControl]="paymentForm" label="Payment">
                        <app-payments-entity-form
                        [enrollmentData]="enrollmentEntityData"
                        [studentData]="studentAccountEntityData"
                        (paymentSubmitted)="onPaymentSubmitted($event)"
                        [isNested]="true">
                      </app-payments-entity-form>
                    </mat-step>

                    <mat-step [stepControl]="completionFormGroup">
                      <ng-template matStepLabel>Done</ng-template>
                      <p>You are now done.</p>
                      <div>
                        <!-- 'field_student_account': this.enrollmentForm?.value?.field_student, -->
                        <button
                            class="me-1"
                            mat-button
                            color="primary"
                            (click)="openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create', '', {
                                'field_type': getFieldTypeBasedOnDepartment(this.enrollmentEntityData?.field_student?.field_student_department),
                                'field_student': [
                                    {
                                        'type': 'attendees',
                                        'title': this.enrollmentEntityData?.field_student?.title,
                                        'field_enrollment': this.enrollmentEntityData?.id,
                                        'field_status': '64',
                                        'field_students': this.enrollmentEntityData?.field_student?.field_contacts,
                                        'field_student_account': this.enrollmentEntityData?.field_student?.title + ' (' + this.enrollmentEntityData?.field_student?.id + ')',
                                        'bundle': 'attendance'
                                    },
                                ],
                                'field_instructor': this.enrollmentForm?.value?.field_instructor_percentages?.[0]?.field_instructor
                            })">
                            Schedule Appointment
                        </button>
                        <button *ngIf="_permissionsService.canAccess('enrollments_create')" mat-button color="primary" (click)="this._dialog.closeAll(); openEntityComponent(EnrollmentEntityComponent, 'packages', 'enrollment', 'create', null)">Add Enrollment</button>
                        <button
                            *ngIf="latestPaymentId"
                            mat-button
                            color="primary"
                            class="ms-1"
                            (click)="openReceiptDialog()">
                            <mat-icon>receipt</mat-icon>
                            View Receipt
                        </button>
                      </div>
                    </mat-step>
                </mat-stepper>

            </mat-tab>

            <mat-tab label="Delete" [disabled]="this.initActionType == 'create'" *ngIf="this.actionType != 'create'">
                <app-error-message [message]=this.errorMessage></app-error-message>
                <app-entity-confirm-delete></app-entity-confirm-delete>
                <app-enrollment-lesson-list-view (dataCountEvent)='updateCount($event)' [enrollmentID]="this.enrollmentID"></app-enrollment-lesson-list-view>
            </mat-tab>

        </mat-tab-group>

    </div>
</div>

<div>
    <!-- <p> -->
    <!-- {{findInvalidControlsRecursive(this?.enrollmentForm) | json}} -->
    <!-- </p> -->
    <!-- {{this?.enrollmentForm?.value | json}} -->
    <!-- enrollmentForm.valid: {{enrollmentForm?.valid}} -->
    <!-- get why the form isn't valid. -->
    <!-- enrollmentForm.errors: {{enrollmentForm?.errors | json}} -->
</div>

<mat-dialog-actions
    [ngClass]="{
        'd-none': !(this.actionType === 'delete' || this.actionType === 'edit')
    }"
    align="end">
    <ng-container *ngIf="this.actionType === 'create'">
        <!-- <button type="button" (click)="onSubmit(f);" mat-raised-button color="accent">Save</button> -->
    </ng-container>
    <ng-container *ngIf="this.actionType === 'edit'">
        <ng-container *ngIf="this.initActionType == 'edit'">
            <button type="button" (click)="setFormMode('delete')" mat-raised-button color="accent">Delete</button>
            <button type="button" (click)="onSubmit(f);" mat-raised-button color="primary">Save</button>
        </ng-container>
        <ng-container *ngIf="this.initActionType === 'create'">
            <button type="button" (click)="closeDialog()" mat-raised-button color="accent">Cancel</button>
            <button type="button" (click)="onSubmit(f);" mat-raised-button color="primary">Save</button>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="this.actionType === 'delete'">
        <button (click)="closeDialog();" type="submit" mat-raised-button color="accent">Cancel</button>
        <button [disabled]="this.eventCount > 0" (click)="onDeleteSubmit(this._injectedDialogData['data']['EntityID'])" type="submit" mat-raised-button
            color="accent">Delete Enrollment</button>
    </ng-container>
</mat-dialog-actions>
